import React from "react"

import { Link } from "gatsby"
import PropTypes from "prop-types"

import * as styles from "./button.module.scss"
import DarkColor from "../../../helpers/dark-color"

const Button = ({
  children,
  url,
  variant,
  fullWidth,
  className,
  internal,
  pressEvent,
  target,
  rel,
  disabled,
  submit,
  large,
  partner,
}) => {
  const fullClass = `${className} ${styles.button} ${
    styles[`button__${variant}`]
  } ${fullWidth ? styles.button__full : ""}  ${
    large ? styles.button__large : ""
  }${
    variant === "partner" &&
    partner?.color?.hex &&
    DarkColor(partner?.color?.hex, true)
      ? styles.button__dark
      : ""
  }`
  if (pressEvent || submit) {
    return (
      <button
        type={submit ? "submit" : "button"}
        onClick={pressEvent}
        onKeyPress={pressEvent}
        className={fullClass}
        disabled={disabled}
      >
        {children}
      </button>
    )
  }
  if (internal) {
    return (
      <Link
        to={url}
        className={fullClass}
        style={
          variant === "partner" && partner?.color?.hex
            ? { backgroundColor: partner?.color?.hex }
            : {}
        }
        target={target}
        rel={rel}
      >
        {children}
      </Link>
    )
  }
  return (
    <a href={url} className={fullClass} target={target} rel={rel}>
      {children}
    </a>
  )
}

export default Button

Button.propTypes = {
  children: PropTypes.node.isRequired,
  url: PropTypes.string,
  variant: PropTypes.string,
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
  internal: PropTypes.bool,
  pressEvent: PropTypes.func,
  target: PropTypes.string,
  rel: PropTypes.string,
  disabled: PropTypes.bool,
  submit: PropTypes.bool,
  large: PropTypes.bool,
  partner: PropTypes.object,
}

Button.defaultProps = {
  url: "",
  variant: "primary",
  fullWidth: false,
  className: "",
  internal: true,
  pressEvent: null,
  target: "_self",
  rel: "",
  disabled: false,
  submit: false,
  large: false,
  partner: null,
}
